export interface Challenge {
  id: string;
  provider: "cap" | "altcha";
  data: unknown;
}
export interface ChallengeRequest {
  challenge: Challenge;
  resolve: (pass: string) => void;
  reject: () => void;
}
let listener: ((request: ChallengeRequest) => void) | undefined;
export function registerChallenge(fn: (request: ChallengeRequest) => void) {
  listener = fn;
  return () => {
    if (listener === fn) listener = undefined;
  };
}
let inlineListener: ((request: ChallengeRequest) => void) | undefined;
export function registerInlineChallenge(
  fn: (request: ChallengeRequest) => void,
) {
  inlineListener = fn;
  return () => {
    if (inlineListener === fn) inlineListener = undefined;
  };
}
export function requestVerification(challenge: Challenge): Promise<string> {
  return new Promise((resolve, reject) => {
    const present = inlineListener ?? listener;
    if (!present) {
      reject(new Error("verification_unavailable"));
      return;
    }
    const timer = setTimeout(
      () => reject(new Error("verification_expired")),
      180000,
    );
    present({
      challenge,
      resolve: (pass) => {
        clearTimeout(timer);
        resolve(pass);
      },
      reject: () => {
        clearTimeout(timer);
        reject(new Error("verification_cancelled"));
      },
    });
  });
}
